module.exports = __webpack_public_path__ + "static/media/code.15be9b5e.png";